const colors = {
  gray20: "#D6D6D6",
  gray50: "#999999",
  tufts150: "#0174DF",
  tufts50: "#85CCF8",
  tufts20: "#CEEBFC",
  tufts10: "#E6F5FD",
  beige: "#FBF3D8",
  royal20: "#CCD5DF",
  royal100: "#012B60",
  spearmint100: "#21CE9D",
  errorRed100: "#D2423A",
  mango50: "#F8C6A7",
  // mango100: '',
  // mango20: ''
} as const;

export const mightierColors = { ...colors, primary: colors.tufts150 };

export type MightierColors = typeof mightierColors;

/**
 * TODO: should probably bake these into a CSS file so that they can be
 * recognized by the cssVariables plugin. Vars are accesible in .module.css
 * BUT it's not clear _how_ just by looking at the code.
 */

export const mightierColorVariables = Object.entries(mightierColors).reduce(
  (acc, [key, value]) => {
    acc[`--mightier-color-${key}`] = value;
    return acc;
  },
  {} as Record<string, string>,
);

export type MightierColorVariables = `--mightier-color-${keyof MightierColors}`;
